<div class="{{styles.radio}}">{{each props.info item index}}<div title="{{item.name}}" data-value="{{item.value}}" class="{{ $imports.classnames([styles.radio_item, item.value === props.value && styles.checked]) }}">{{item.name | maxLength props.maxTextLength}}</div>{{/each}}</div>


// WEBPACK FOOTER //
// ./D:/project/issts/oy-search-component/src/components/OYRadio/index.art